import { render } from "./TwitterFeed.vue?vue&type=template&id=7cf7bb20"
import script from "./TwitterFeed.vue?vue&type=script&lang=js"
export * from "./TwitterFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__